
export class GoCheckHistory {

  constructor($) {
    this.$ = $;
    this.$el = this.$('.td-container-gocheck-history');
    if (!this.$el.length) {
      // This happens if we are not on the dashboard and we don't want to
      // load the GoCheckHistory. It's needed since the script is loaded
      // always.
      return;
    }

    this.isLoading = false;
    this.currentLp = '';
    this.pendingXhr = null;
    this.languagePairs = {};
    this.summaryTemplate = this.$('#gocheck-summary-template').html();
    this.loadingAnimation = this.$el.find('.gocheck-history-loading');
    this.bindEvents();

    this.$el.find('.gocheck-history-tab li.active').trigger('click');
  }

  lp() {
    return this.languagePairs[this.currentLp];
  }

  bindEvents() {
    this.$el.find('.gocheck-history-tab li')
      .on('click', this.onTabClick.bind(this));

    this.$(window).scroll(this.onScroll.bind(this));

    this.$el.find('.table-gocheck-history')
      .on('click', 'tbody > tr', this.onRowClick.bind(this));
  }

  onRowClick(event) {
    if ((event.ctrlKey && !event.metaKey) ||
      (!event.ctrlKey && event.metaKey)) {
      // Ignore if press on Command (Mac) or Ctrl (Windows) key.
      return;
    }
    const url = this.$(event.currentTarget).data('workbench-url');
    document.location.href = url;
  }

  onTabClick(event) {
    event.preventDefault();

    if (this.pendingXhr !== null) {
      this.pendingXhr.event = event;
      this.pendingXhr.abort();
      return;
    }
    const selection = $(event.currentTarget);
    this.currentLp = selection.find('a').data('lp');

    this.$el.find('.gocheck-history-box tbody').hide();
    this.$el.find('.gocheck-history-summary div').hide();
    this.initTable();

    if (!this.lp().lastPage) {
      this.addPage();
    }

    window.history.pushState(
      {},
      '',
      `history?lc_src=${this.lp().src}&lc_tgt=${this.lp().tgt}`
    );
    this.$el.find('.gocheck-history-tab li').removeClass('active');
    selection.addClass('active');

    this.$el.find('.gocheck-history-summary div.' + this.currentLp).show();
    this.$el.find('tbody#' + this.currentLp).show();
  }

  initTable() {
    if (!this.languagePairs.hasOwnProperty(this.currentLp)) {
      const lp = this.currentLp.split('_');
      this.languagePairs[this.currentLp] = {
        page: -1,
        lastPage: false,
        src: lp[0],
        tgt: lp[1]
      };
      this.$el.find('.table-gocheck-history').append(
        `<tbody id="${this.currentLp}"></tbody>`
      );
    }
  }

  addPage() {
    if (this.isLoading) {
      return;
    }

    this.loadingAnimation.show();
    this.isLoading = true;
    this.lp().page += 1;

    this.pendingXhr = this.$.ajax({
      url: '/t/ajax/gocheck_history',
      type: 'GET',
      data: {
        page: this.lp().page,
        lc_src: this.lp().src,
        lc_tgt: this.lp().tgt
      },
      context: this,
      success: (data) => {
        if (data.last_page) {
           this.lp().lastPage = true;
           this.lp().totalGoChecks = data.total_gochecks;
           this.showGoCheckSummary();
        }
        this.$('#' + this.currentLp).append(data.view);
        this.pendingXhr = null;
        this.isLoading = false;
        this.loadingAnimation.hide();
      },
      error: (data) => {
        /**
         * If user changes tab while we are requesting data we abort
         * the request and the error handler will be called so we
         * can do some cleanup and request data for the new active
         * tab.
         */
        this.lp().page -= 1;
        this.pendingXhr = null;
        this.isLoading = false;
        this.loadingAnimation.hide();
        if (data.readyState === XMLHttpRequest.UNSENT) {
          this.onTabClick(data.event);
          this.addPage();
        }
      }
    });
  }

  showGoCheckSummary() {
    const template = this.$(this.summaryTemplate);
    template.addClass(this.currentLp);
    template.find('.gocheck-history-summary-count').text(this.lp().totalGoChecks);
    template.find('.gocheck-history-summary-lp').text(this.lp().src + ' > ' + this.lp().tgt);
    this.$('.gocheck-history-summary').append(template);
  }

  onScroll() {
    if (
      !this.lp().lastPage &&
      this.isInView(this.$('.table-gocheck-history > tbody:visible > tr:last-child'))
    ) {
      this.addPage(this.$('.gocheck-history-tab li.active').find('a').data('lp'));
    }
  }

  isInView(elem) {
    if (!this.$(elem).length) {
      return false;
    }

    const docViewTop = this.$(window).scrollTop();
    const docViewBottom = docViewTop + $(window).height();
    const elemTop = this.$(elem).offset().top;
    const elemBottom = elemTop + this.$(elem).height();
    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }
}



// WEBPACK FOOTER //
// ./style-guide-extends/js/translator-dashboard/gocheck_history.js